export enum ACCESS_ERROR_TYPE {
  ERROR = 'error',
  WARN = 'warn',
}

export enum ACCESS_ERROR_CODE {
  MISSING_SESSION_TOKEN = 'MISSING_SESSION_TOKEN',
}

export enum ACCESS_UPDATE_CODE {
  TRAVEL_CLIENT_LOADED = 'TRAVEL_CLIENT_LOADED',
  ACTIVE_SESSION_PING = 'ACTIVE_SESSION_PING',
  TRAVEL_CLIENT_SESSION_EXPIRED = 'TRAVEL_CLIENT_SESSION_EXPIRED',
  SESSION_NOT_FOUND = 'SESSION_NOT_FOUND',
}

export interface IAccessErrorEvent {
  error_code: ACCESS_ERROR_CODE
  error_message: string
  error_type: ACCESS_ERROR_TYPE
  status: number
}

export interface IAccessUpdateEvent {
  update_code: ACCESS_UPDATE_CODE
  update_message: string | null
}
